import { useEffect, useState } from "react";
import { Palette, Check } from "lucide-react";
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuLabel, DropdownMenuTrigger } from "@/components/ui/dropdown-menu";
import { THEMES, getTheme, setTheme } from "@/lib/theme";
import { api } from "@/lib/api";

export function ThemeSwitcher({ fallback = "orbis", persist = false }) {
  const [cur, setCur] = useState(getTheme() || fallback);
  const pick = (id) => { setTheme(id); setCur(id); if (persist) api.put("/auth/me", { theme: id }).catch(() => {}); };
  useEffect(() => { const h = () => setCur(getTheme() || fallback); window.addEventListener("orbis-theme", h); return () => window.removeEventListener("orbis-theme", h); }, [fallback]);
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild><button data-testid="theme-switcher" title="Theme" className="inline-flex items-center gap-1.5 text-xs font-mono px-2 py-1 rounded border hover:bg-secondary transition-colors"><Palette className="h-3.5 w-3.5" /></button></DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="bg-card w-56">
        <DropdownMenuLabel className="eyebrow">Theme</DropdownMenuLabel>
        {THEMES.map((t) => <DropdownMenuItem key={t.id} data-testid={`theme-${t.id}`} onClick={() => pick(t.id)} className="flex items-center gap-2">
          <span className="flex gap-0.5">{t.swatch.map((c) => <span key={c} className="h-3.5 w-3.5 rounded-sm border border-black/10" style={{ background: c }} />)}</span><span className="flex-1 text-sm">{t.name}</span>{cur === t.id && <Check className="h-3.5 w-3.5" />}
        </DropdownMenuItem>)}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
